import { type ClassValue, clsx } from "clsx";
import { addSeconds, format, parseISO } from "date-fns";
import { twMerge } from "tailwind-merge";

import { AnalyticsPeriod } from "@/data/types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertTimeFromSeconds(seconds: number) {
  const time = addSeconds(new Date(0), seconds);
  return format(time, "HH:mm:ss");
}

export function formatByPeriod(value: string, period?: AnalyticsPeriod) {
  try {
    const date = parseISO(value);

    switch (period) {
      case AnalyticsPeriod.MONTH:
        return new Intl.DateTimeFormat(undefined, {
          month: "short",
          year: "numeric",
        }).format(date);
      case AnalyticsPeriod.WEEK:
        return new Intl.DateTimeFormat(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
        }).format(date);
      case AnalyticsPeriod.DAY:
        return new Intl.DateTimeFormat(undefined, {
          month: "short",
          day: "numeric",
        }).format(date);
      default:
      case AnalyticsPeriod.HOUR:
        return new Intl.DateTimeFormat(undefined, {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }).format(date);
    }
  } catch (exception) {
    return value;
  }
}
